import { parseSiteBriefSummary } from '../utils/siteBriefSummary';

function SummaryText({ text }: { text: string }) {
  return <>{text.split(/(\*\*[^*]+\*\*)/g).map((part, index) => (
    part.startsWith('**') && part.endsWith('**')
      ? <strong key={index}>{part.slice(2, -2)}</strong>
      : part
  ))}</>;
}

export default function SiteBriefSummary({ summary, language }: { summary: string; language: string }) {
  return (
    <div className="sb-brief-summary" lang={language}>
      {parseSiteBriefSummary(summary).map((block, index) => {
        if (block.kind === 'heading') return <h3 key={index}><SummaryText text={block.text} /></h3>;
        if (block.kind === 'list') return (
          <ul key={index}>{block.items.map((item, itemIndex) => <li key={itemIndex}><SummaryText text={item} /></li>)}</ul>
        );
        return <p key={index}><SummaryText text={block.text} /></p>;
      })}
    </div>
  );
}
